module.exports = __webpack_public_path__ + "static/img/img(59).4c523b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(59).png
// module id = ANoI
// module chunks = 1